import React, {useEffect} from "react";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/application-breadcrumb.webp'
import Application from "../Components/Application";
import ApplicationTable from "../Components/ApplicationTable";
import Products from "../Components/Products";
import Cta from "../Components/Cta";

const Applications=()=>{

    useEffect(() => {
                document.title =
                  "Tile Adhesive Applications for Walls & Floors | VigoFlex";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Discover the right adhesive for every surface. From bathrooms to swimming pools, VigoFlex offers specialized solutions for all tiling needs in India."
                  );
                }
            
                 const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://vigoflex.in/applications");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Tile Adhesive Applications for Walls & Floors | VigoFlex"
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Discover the right adhesive for every surface. From bathrooms to swimming pools, VigoFlex offers specialized solutions for all tiling needs in India."
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://vigoflex.in/applications");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://vigoflex.in/files/applications-img.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Tile Adhesive Applications for Walls & Floors | VigoFlex"
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Discover the right adhesive for every surface. From bathrooms to swimming pools, VigoFlex offers specialized solutions for all tiling needs in India."
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://vigoflex.in/files/applications-img.webp"
                );
              }
              }, [])
    return(
        <>
        {/**BREADCRUMB */}
        <Breadcrumb
        title="Application"
        bgImage={bgImg}
      />

       {/**APPLICATIONS SECTION */}
        <div className="about-pg">
        <Application />
        </div>

        {/**COMPARISON TABLE */}
        <ApplicationTable />

         {/**PRODUCTS GRID */}
        <Products/>

      <div style={{ marginTop: "80px" }}></div>
      
        {/**CTA SECTION */}
        <Cta />
        </>
    )
}
export default Applications;